import React from 'react';
import PropTypes from 'prop-types';
import { WithIconRounded } from 'Components/ProfileMultiProduct/components/designSystem';

const MasterCardLogo = ({
  borderColor,
  borderWidth,
  className,
  containerColor,
  containerSize,
  height,
  onClick,
  padding,
  round,
  width,
}) => (
  <WithIconRounded
    borderColor={borderColor}
    borderWidth={borderWidth}
    className={className}
    containerColor={containerColor}
    containerSize={containerSize}
    onClick={onClick}
    padding={padding}
    round={round}
  >
    <svg
      width={width}
      height={height}
      viewBox="0 0 39 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <path d="M19.3999 2.55261C16.5991 4.74939 14.7998 8.16455 14.7998 12C14.7998 15.8354 16.5991 19.2506 19.3999 21.4474C19.4785 21.3857 19.5562 21.3232 19.6333 21.2598C17.5591 22.9717 14.8994 24 12 24C5.37256 24 0 18.6274 0 12C0 5.37256 5.37256 0 12 0C14.7925 0 17.3608 0.952759 19.3999 2.55261Z" fill="#FF0015" />
      <path d="M19.3999 21.4475C22.2006 19.2507 24 15.8355 24 12C24 8.16457 22.2006 4.74938 19.3999 2.55261C16.5992 4.74938 14.7998 8.16457 14.7998 12C14.7998 15.8355 16.5992 19.2507 19.3999 21.4475Z" fill="#FF5F00" />
      <path d="M26.7998 24C33.4272 24 38.7998 18.6274 38.7998 12C38.7998 5.37256 33.4272 0 26.7998 0C23.9004 0 21.2407 1.02832 19.1665 2.74023C19.2437 2.67676 19.3213 2.61426 19.3999 2.55261C22.2007 4.74939 24 8.16455 24 12C24 15.8354 22.2007 19.2507 19.3999 21.4475C21.4385 23.0466 24.0078 24 26.7998 24Z" fill="#FF9F00" />
    </svg>
  </WithIconRounded>
);

MasterCardLogo.propTypes = {
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  className: PropTypes.string,
  containerColor: PropTypes.string,
  containerSize: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func,
  padding: PropTypes.number,
  round: PropTypes.bool,
  width: PropTypes.number,
};

MasterCardLogo.defaultProps = {
  borderColor: '',
  borderWidth: 0,
  className: 'k-ds-bg-color-light-grey-300',
  containerColor: null,
  containerSize: 40,
  height: 30,
  onClick: null,
  padding: 0,
  round: false,
  width: 99,
};

export default MasterCardLogo;
